module.exports = __webpack_public_path__ + "media/images/logo-36e3afa3a09715f8739c99dede4a734a.png";